import React from 'react';
import Component from '@vfuk/core-overlay';
const Overlay = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Overlay;
